module.exports = "<div  layout-fill class=\"resource\">\n    <!-- <iframe \n        ng-src=\"{{'assets/resource/apps/fhome-radio/index.html#/init-cloud-resource?resource-uuid='\n            + currentResource.uniqueId\n            + '&cloud-account-email=chmuraniedziala@gmail.com'}}\" \n        class=\"frame\">\n    </iframe> -->\n    <iframe \n        ng-src=\"{{resourceUrl}}\" \n        class=\"frame\">\n    </iframe>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/users/resource/fhomeradio.html
// module id = 262
// module chunks = 0